import ReactGA from 'react-ga4';

const GA_ID = process.env.REACT_APP_GA_ID;
const isLocal = window.location.hostname === 'localhost';

export const initGA = () => {
  if (GA_ID && !isLocal) {
    ReactGA.initialize(GA_ID);
    console.log(`[GA Initialized] ${process.env.NODE_ENV} mode with ID: ${GA_ID}`);
  } else {
    console.log('[GA Disabled] Localhost or missing GA ID.');
  }
};

export const logPageView = (path) => {
  if (GA_ID && !isLocal) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};
